import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 2.577a2 2 0 0 0-2 0L4.34 6.423a2 2 0 0 0-1 1.732v7.69a2 2 0 0 0 1 1.732L11 21.423a2 2 0 0 0 2 0l6.66-3.846a2 2 0 0 0 1-1.732v-7.69a2 2 0 0 0-1-1.732zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
      clipRule: "evenodd"
    }
  )
);
var SvgSettingsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SettingsFilled_default = SvgSettingsFilled;

export { SettingsFilled_default as default };
